import { apiClient } from "./client";
import type { Notification } from "@abejon/shared";

export async function getNotifications(page = 1, limit = 20) {
  return apiClient<{ notifications: Notification[]; page: number; limit: number }>(
    `/notifications?page=${page}&limit=${limit}`
  );
}

export async function getUnreadCount() {
  return apiClient<{ unreadCount: number }>("/notifications/unread-count");
}

export async function markAllRead() {
  return apiClient<{ success: boolean }>("/notifications/read-all", {
    method: "PATCH",
  });
}

export async function markRead(id: string) {
  return apiClient<{ success: boolean }>(`/notifications/${id}/read`, {
    method: "PATCH",
  });
}

export async function getVapidPublicKey() {
  return apiClient<{ publicKey: string }>("/notifications/push/vapid-key");
}

export async function subscribePush(subscription: PushSubscription) {
  const json = subscription.toJSON();
  return apiClient<{ success: boolean }>("/notifications/push/subscribe", {
    method: "POST",
    body: {
      endpoint: json.endpoint,
      keys: {
        p256dh: json.keys?.p256dh,
        auth: json.keys?.auth,
      },
    },
  });
}

export async function unsubscribePush(endpoint: string) {
  return apiClient<{ success: boolean }>("/notifications/push/subscribe", {
    method: "DELETE",
    body: { endpoint },
  });
}
